export enum AccessTypeEnum {
  fullAccess = 'full_access',
  partialAccess = 'partial_access',
  drippingContent = 'dripping_content',
  partialDrippingAccess = 'partial_dripping_access',
}

export const AccessTypeCaptions = {
  [AccessTypeEnum.fullAccess]: 'dashboard.course.access_type.full_access',
  [AccessTypeEnum.partialAccess]: 'dashboard.course.access_type.partial_access',
  [AccessTypeEnum.drippingContent]: 'dashboard.course.access_type.drip_content',
  [AccessTypeEnum.partialDrippingAccess]: 'dashboard.course.access_type.partial_dripping_access',
}
